import React from "react";
import { CustomerDropDown, DropDown } from "@src/components/atoms";

export const CustomerAndPageSelector = (props) => {
  const {
    pageOptions,
    currentPageValue,
    handleChangeCustomer,
    handleChangePage,
  } = props;
  return (
    <>
      <section className="m-4">
        <CustomerDropDown onChange={(e) => handleChangeCustomer(e)} />
      </section>
      <section className="m-4">
        <h4>Select an editable page</h4>
        <DropDown
          options={pageOptions}
          value={currentPageValue}
          onChange={(e) => {
            handleChangePage(e);
          }}
        />
      </section>
    </>
  );
};
